const showSidebar = user => {
  // only consumers and Stripe-onboarded creators should see the sidebar
  return user && (user.connected_for_payment || user.creator === false);
};

export default showSidebar;
